import {
  Component,
  computed,
  effect,
  ElementRef,
  inject,
  input,
  output,
  viewChildren,
} from '@angular/core';
import { NgStyle } from '@angular/common';
import { ExtractedLocationData } from '../../../../models/interfaces';
import {
  Dimension2d,
  OverlayRectComponent,
  RectDisplayStylePipe,
  ScaleRectPipe,
  WordRect,
} from '@ps-gui/claims-terminal-shared';
import { FieldHighlightRefService } from '../../../../service/field-highlight-ref.service';
import { getUnionRect } from '../../../../service/ocr/ocr-utils';

@Component({
  selector: 'ct-extraction-text-selection-overlay',
  imports: [OverlayRectComponent, RectDisplayStylePipe, NgStyle, ScaleRectPipe],
  templateUrl: './text-selection-overlay.component.html',
})
export class TextSelectionOverlayComponent {
  private readonly fieldHighlightRefService = inject(FieldHighlightRefService);

  readonly selectedWordsRect = input.required<WordRect[]>();
  readonly lasso = input<WordRect>();
  readonly showTextSelectionOverlay = input.required<boolean>();

  readonly highlight = input<ExtractedLocationData>();

  changeAutoUpdate = output<boolean>();

  readonly fieldHighlight = viewChildren<ElementRef<HTMLDivElement>>('fieldHighlight');

  readonly dimension = input.required<Dimension2d>();

  readonly unionRect = computed(() => {
    if (!this.highlight()) return {} as WordRect;

    return getUnionRect(this.highlight()!.selection.flat());
  });

  constructor() {
    effect(() => {
      const imageContainer = document.getElementById('img-container')!;

      if (!this.highlight()) {
        this.fieldHighlightRefService.setElementRef(new ElementRef(imageContainer));
        return;
      }

      this.changeAutoUpdate.emit(true);

      setTimeout(() => {
        const element = this.fieldHighlight()[0]?.nativeElement;
        if (!element) return;

        const rect = element.getBoundingClientRect();

        this.fieldHighlight()[0]?.nativeElement.scrollIntoView({
          behavior: 'smooth',
          block: 'center',
        });

        this.fieldHighlightRefService.setElementRef(this.fieldHighlight()[0]);

        const hasBeenScrolled =
          imageContainer.scrollTop === 0
            ? rect.top > imageContainer.offsetHeight / 2
            : imageContainer.scrollTop === imageContainer.scrollHeight - imageContainer.offsetHeight
              ? rect.top < (imageContainer.scrollHeight - imageContainer.offsetHeight) / 2
              : true;

        if (hasBeenScrolled) return;
        this.changeAutoUpdate.emit(false);
      });
    });
  }
}
